import * as React from 'react';
import './Input.css';
import { GetGuid } from '../lib';

interface IInputProps {
    type: string;
    id?: string;
    value?: string;
    placeholder?: string;
    width?: string;
    valid?: boolean;
    invalid?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    OnChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    colorText?: string;
}
/*
type InputType =
    | 'text'
    | 'windows'
    | 'email'
    | 'number'
    | 'password'
    | 'phone'
    | 'find';
*/
const RegPhonInput: RegExp = /\+(\d{1})[-(]?(\d{3})[-)]?(\d{3})[-]?(\d{2})[-]?(\d{2})/;
const RegPhonView = '+$1($2)$3-$4-$5';
const RegPhonToBD = '$1$2$3$4$5';

class Input extends React.Component<IInputProps> {
    constructor(props: IInputProps) {
        super(props);
    }
    render() {
        let width: string = this.props.width !== undefined ? this.props.width : 'calc(100% - 16px)';
        let id: string = this.props.id !== undefined ? this.props.id : GetGuid();
        let type: string = 'text';
        let placeholder: string = '';
        let value: string = '';
        let className: string = 'input_def';
        let colorText: string = this.props.colorText !== undefined ? this.props.colorText : '#000';

        if (this.props.placeholder !== undefined) placeholder = this.props.placeholder;

        if (this.props.valid && !this.props.invalid) className = className + ' valid';
        if (!this.props.valid && this.props.invalid) className = className + ' invalid';

        if (this.props.value !== undefined) value = this.props.value;

        let SCGView = this.props.valid ? (
            <svg
                className="input_def_valid"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.39959 0.429971C6.89263 2.89964 5.31526 5.32212 3.68155 7.69741C2.9492 6.98954 2.20276 6.28167 1.47041 5.57381C0.653553 4.78729 -0.543561 6.10864 0.273293 6.91089C1.24507 7.85471 2.21684 8.78281 3.2027 9.72663C3.51254 10.0255 4.10406 10.1514 4.39982 9.72663C6.30112 7.021 8.132 4.23672 9.85021 1.38952C10.4699 0.36705 9.00519 -0.576773 8.39959 0.429971Z"
                    fill="#66C3D0"
                />
            </svg>
        ) : (
            ''
        );
        if (this.props.type == 'number') {
            type = 'number';
            placeholder = '';
        } else if (this.props.type == 'password') {
            type = 'password';
            value = '';
        } else if (this.props.type == 'email') {
            type = 'email';
        } else if (this.props.type == 'windows') {
        /*
        else if (props.type == "phone") {
            placeholder = "+70001112233 или +7(000)111-22-33";
        }
        */
            SCGView = (
                <div
                    id={'button_' + id}
                    className="input_def_svg"
                    onClick={this.props.onClick}
                    style={{ width: '20px', height: '20px', cursor: 'pointer' }}>
                    <svg width="11" height="3" viewBox="0 0 11 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1.39551 0.501953C1.7054 0.501953 1.94466 0.59082 2.11328 0.768555C2.2819 0.941732 2.36621 1.16048 2.36621 1.4248C2.36621 1.68457 2.2819 1.90104 2.11328 2.07422C1.94466 2.24284 1.7054 2.32715 1.39551 2.32715C1.09928 2.32715 0.864583 2.24284 0.691406 2.07422C0.518229 1.9056 0.431641 1.68913 0.431641 1.4248C0.431641 1.16048 0.515951 0.941732 0.68457 0.768555C0.85319 0.59082 1.09017 0.501953 1.39551 0.501953ZM5.30566 0.501953C5.61556 0.501953 5.85482 0.59082 6.02344 0.768555C6.19206 0.941732 6.27637 1.16048 6.27637 1.4248C6.27637 1.68457 6.19206 1.90104 6.02344 2.07422C5.85482 2.24284 5.61556 2.32715 5.30566 2.32715C5.00944 2.32715 4.77474 2.24284 4.60156 2.07422C4.42839 1.9056 4.3418 1.68913 4.3418 1.4248C4.3418 1.16048 4.42611 0.941732 4.59473 0.768555C4.76335 0.59082 5.00033 0.501953 5.30566 0.501953ZM9.21582 0.501953C9.52572 0.501953 9.76497 0.59082 9.93359 0.768555C10.1022 0.941732 10.1865 1.16048 10.1865 1.4248C10.1865 1.68457 10.1022 1.90104 9.93359 2.07422C9.76497 2.24284 9.52572 2.32715 9.21582 2.32715C8.9196 2.32715 8.6849 2.24284 8.51172 2.07422C8.33854 1.9056 8.25195 1.68913 8.25195 1.4248C8.25195 1.16048 8.33626 0.941732 8.50488 0.768555C8.6735 0.59082 8.91048 0.501953 9.21582 0.501953Z"
                            fill="#C8C8C8"
                        />
                    </svg>
                </div>
            );
        } else if (this.props.type == 'find') {
            placeholder = 'Поиск';
            value = ''; //?
            className = 'input_def find';
            SCGView = (
                <svg
                    className="input_def_svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M11.7581 11.3147L8.03902 7.5605C8.7938 6.65264 9.1726 5.48536 9.09639 4.30212C9.02019 3.11888 8.49486 2.01106 7.62999 1.20972C6.76512 0.408378 5.62749 -0.0246049 4.45438 0.0010808C3.28126 0.0267665 2.16326 0.509137 1.33354 1.34758C0.503834 2.18603 0.0264876 3.3158 0.00106954 4.50126C-0.0243486 5.68673 0.404124 6.83633 1.19712 7.71031C1.99011 8.58428 3.08639 9.11514 4.25731 9.19215C5.42822 9.26915 6.58334 8.88637 7.48175 8.12364L11.1969 11.8819C11.2336 11.9193 11.2773 11.949 11.3255 11.9693C11.3736 11.9896 11.4253 12 11.4775 12C11.5297 12 11.5813 11.9896 11.6295 11.9693C11.6776 11.949 11.7213 11.9193 11.7581 11.8819C11.7951 11.8447 11.8245 11.8006 11.8446 11.7519C11.8647 11.7032 11.875 11.651 11.875 11.5983C11.875 11.5456 11.8647 11.4934 11.8446 11.4447C11.8245 11.396 11.7951 11.3519 11.7581 11.3147ZM0.806383 4.60904C0.806383 3.85862 1.02659 3.12506 1.43915 2.50111C1.85172 1.87716 2.43812 1.39086 3.12419 1.10368C3.81026 0.816513 4.56519 0.741376 5.29352 0.887775C6.02185 1.03417 6.69087 1.39553 7.21596 1.92616C7.74106 2.45678 8.09866 3.13284 8.24353 3.86883C8.3884 4.60483 8.31405 5.36771 8.02987 6.06101C7.74569 6.7543 7.26445 7.34687 6.647 7.76378C6.02955 8.18069 5.30363 8.40321 4.56103 8.40321C3.56556 8.40215 2.61115 8.00207 1.90725 7.29075C1.20334 6.57944 0.807429 5.61499 0.806383 4.60904Z"
                        fill="#A5A5A5"
                    />
                </svg>
            );
        }

        let sty = {
            width: width,
            color: colorText
        };

        return (
            <React.Fragment key={id + value}>
                <input
                    id={id}
                    style={sty}
                    type={type}
                    className={className}
                    placeholder={placeholder}
                    defaultValue={value}
                    onBlur={this.props.onBlur}
                    onChange={this.props.OnChange}
                    disabled={this.props.disabled}
                />
                {SCGView}
            </React.Fragment>
        );
    }
}

export default Input;
